<template>
  <div class="py-5">
    <h4
      v-if="isProcessing"
      class="card__loader-text text-xs-center pb-5"
      v-html="$t(`${namespace}.waitAfewMoments`)"
    />
    <transition name="fade">
      <div class="text-xs-center py-4">
        <v-progress-circular :size="60" indeterminate color="accent" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Processing',
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      namespace: 'Views.ConsolidatedReportPage',
      currentStatus: null
    }
  }
}
</script>
